module.exports = __webpack_public_path__ + "fonts/fa-solid-900.781e85b.ttf";